
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`À Lausanne et Yverdon, plusieurs
`}<a parentName="p" {...{
        "href": "https://www.24heures.ch/vaud-regions/nord-vaudois-broye/application-tracage-creee-lepfl-testee-caserne/story/23419337"
      }}>{`tests`}</a>{`
avec jusqu'à 100 soldats de l'armée suisse ont été effectués ces derniers jours.
L'objectif était de calibrer l'algorithme de l'EPFL pour différentes
`}<a parentName="p" {...{
        "href": "https://twitter.com/EPFL_en/status/1253762510467084293?s=20"
      }}>{`situations de la vie quotidienne`}</a>{`
– par exemple, un repas dans un restaurant ou un trajet dans un train. Il faut
pouvoir estimer la distance entre deux utilisateurs le plus précisément
possible, quel que soit le modèle de smartphone utilisé ou l'endroit où il se
trouve (dans la main, dans la poche ou dans le sac à main).`}</p>
    <p>{`La mesure de la distance avec la technologie Bluetooth n'est pas parfaite, mais
cela semble être suffisamment précis pour avoir de bonnes chances de succès.
Depuis la fin mai, l'application a été testée dans une phase pilote par plus de
160 000 employés de la Confédération, des autorités sanitaires cantonales et des
deux écoles polytechniques fédérales. Grâce à de nouveaux tests en laboratoire
et sur le terrain, les résultats sont constamment améliorés.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;